// extracted by css-extract-rspack-plugin
export default {"container":"pfzhrUgAyAwmpqPB","icon":"wcbfMFrh0k_J8MX1"};